import { createElement } from 'react'
import toast from 'react-hot-toast'
import { ToastCard } from '../Toast'

/*
 * Error and info toasts — since #223 in the same card as `showSuccessToast` and `showUndoToast`
 * (icon · title · optional text · ✕). Together these are the only way the app shows a toast — the
 * mobile app swaps the implementation behind these names, the call sites stay. `react-hot-toast`
 * itself is imported only in the toast wrappers and in `AppToaster`.
 */

export interface MessageToastOptions {
  /** Zweite Zeile, nur wo sie etwas sagt (#223). */
  description?: string
  /** Wie lange er steht, in ms; ohne Angabe die des Toasters. `Infinity` für einen Lauf, der ihn selbst schließt. */
  duration?: number
}

/** Error message (red icon). Returns the toast id. */
export function showErrorToast(message: string, { description }: MessageToastOptions = {}): string {
  return toast.custom(
    (t) => createElement(ToastCard, { kind: 'error', title: message, description, onDismiss: () => toast.dismiss(t.id) }),
    { ariaProps: { role: 'alert', 'aria-live': 'assertive' } },
  )
}

/** Neutral hint (info icon). Returns the toast id. */
export function showInfoToast(message: string, { description, duration }: MessageToastOptions = {}): string {
  return toast.custom(
    (t) => createElement(ToastCard, { kind: 'info', title: message, description, onDismiss: () => toast.dismiss(t.id) }),
    duration === undefined ? undefined : { duration },
  )
}

/** Closes a toast shown by any of the wrappers. */
export function dismissToast(id: string): void {
  toast.dismiss(id)
}
